interface BankInfoLinkCellDelegate
{
    linkCellDidTapLink(cell:BankInfoLinkCell, entry:BankEntry): void;
}

// Section header row: the LINK_WITH_ title with the link button at the right
class BankInfoLinkCell extends UITableViewCell
{
    delegate:BankInfoLinkCellDelegate = null;

    private linkButton:MUIButton = null;

    private _entry:BankEntry = null;

    awakeFromHTML() {
        this.linkButton = MUIOutlet(this, "link-btn", "MUIButton");
        this.linkButton.setAction(this, function(this:BankInfoLinkCell) {
            if (this.delegate != null) {
                this.delegate.linkCellDidTapLink(this, this._entry);
            }
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set entry(value:BankEntry) {
        this._entry = value;
    }
}
